<script lang="ts" setup>
	import type { ColumnType } from 'ant-design-vue/lib/table'

	defineProps<{
		tableColumns: TableColumn[]
		loading?: boolean
		tableRecord: DynamicTableContext[] | []
		requiredFields?: string[]
	}>()
</script>

<template>
	<div>
		<table class="relative mx-auto my-10 table w-full">
			<thead class="w-full bg-gray-100">
				<tr>
					<th
						v-for="(item, i) in tableColumns"
						:key="item.key"
						:class="[item?.className]"
						:data-testid="`th-cell-${i}`"
						class="min-w-[100px] whitespace-nowrap border-b border-r p-5 text-left text-sm font-medium capitalize text-gray-600 first:min-w-fit last:border-r-0"
					>
						<slot :name="`column(${item.key})`" :content="item">
							{{ item.title }}
						</slot>
					</th>
				</tr>
			</thead>

			<tbody>
				<tr v-for="(record, i) in tableRecord" :key="i">
					<template v-for="column in tableColumns" :key="column.key">
						<td
							:class="[
								column?.class,
								{
									'bg-gray-100': record.isActive || record.editable,
									'bg-white': record.done
								}
							]"
							class="my-0 border-b border-r py-0"
							:data-testid="`cell-${i}`"
						>
							<slot name="body" :record="record" :column="column" :index="i" />
						</td>
					</template>
				</tr>
			</tbody>
		</table>
	</div>
</template>
